import { PreventBrowserScroll } from "@homebound/beam";
import { Outlet } from "react-router-dom";
import { GlobalNav } from "src/routes/layout/global-nav/GlobalNav";
import { LoggedInPageWrapper } from "src/routes/layout/LoggedInPageWrapper";
import { EnvBanner } from "../EnvBanner";

/**
 * Global nav + logged-in page wrapper above the matched child route.
 *
 * Role: data router pathless layout. Nest under a domain `RouteObject` in `src/routing/domains/*.ts`.
 * See DESIGN.md "Chrome wrappers".
 *
 * `PreventBrowserScroll` lives here (not in `AuthenticatedShell`) so sibling layout routes
 * (e.g. a future Beam `NavbarLayout`) can use different scroll behavior.
 */
export function GlobalNavLayout() {
  return (
    <PreventBrowserScroll>
      <EnvBanner />
      <GlobalNav />
      <LoggedInPageWrapper>
        <Outlet />
      </LoggedInPageWrapper>
    </PreventBrowserScroll>
  );
}
